var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4501 9.44998L6.45007 6.44998L8.45007 14.45L10.3719 11.5203L12.8368 13.9656L13.5126 13.2859L11.0204 10.864L14.4501 9.44998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55005 1.94999C1.55005 1.72907 1.72913 1.54999 1.95005 1.54999H11.95C12.171 1.54999 12.35 1.72907 12.35 1.94999V6.94999C12.35 7.1709 12.171 7.34999 11.95 7.34999C11.7291 7.34999 11.55 7.1709 11.55 6.94999V2.34999H2.35005V11.05H5.95005C6.17096 11.05 6.35005 11.2291 6.35005 11.45C6.35005 11.6709 6.17096 11.85 5.95005 11.85H1.95005C1.72913 11.85 1.55005 11.6709 1.55005 11.45V1.94999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.46ec9d4e3496aff98dd5a5906fa1956c.svg";
export { ForwardRef as ReactComponent };